<script>
import ArticleContent from "@/components/article/ArticleContent.vue";
import ArticleContentCollapser from "@/components/article/ArticleContentCollapser.vue";

import ArticleContentElaborations from "./ArticleContentElaborations.vue";
import ArticleContentHeader from "./ArticleContentHeader.vue";
import ArticleContentMeaning from "./ArticleContentMeaning.vue";

export default {
  name: "ChildrensDanishArticleContent",
  components: {
    ArticleContent,
    ArticleContentCollapser,
    ArticleContentElaborations,
    ArticleContentHeader,
    ArticleContentMeaning
  },
  props: {
    article: {
      type: Object,
      required: true
    },
    hasReadingLines: {
      type: Boolean,
      // eslint-disable-next-line vue/no-boolean-default
      default: true
    },
    isCollapsible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      activeIllustrationUrl: this.article.word.illustration
    };
  },
  computed: {
    baseMeaning() {
      for (let i = 0; i !== this.article.meanings.length; ++i) {
        const meaning = this.article.meanings[i];

        if (meaning.polysem === "") {
          return meaning.comment;
        }
      }

      return null;
    },

    showElaborationsSpacing() {
      const { flexion, hyphenation, abbreviation, grammar, reference } = this.article.word;
      const empty = [flexion, hyphenation, abbreviation, grammar, reference].filter((item) => {
        if (Array.isArray(item)) {
          return item.length !== 0;
        }

        return item.trim() !== "";
      });

      return empty.length !== 0 && this.article.meanings[0].polysem !== "";
    }
  }
};
</script>

<template>
  <ArticleContent>
    <ArticleContentHeader
      :article="article"
      :base-meaning="baseMeaning"
      :active-illustration-url="activeIllustrationUrl"
      @hide-image="activeIllustrationUrl = ''"
      @show-image="activeIllustrationUrl = article.word.illustration"
    />
    <ArticleContentCollapser :is-collapsible="isCollapsible">
      <div
        class="article-content__body-container d-flex flex-column flex-lg-row"
        :class="{ 'article-content__body-container--reading-lines': hasReadingLines }"
      >
        <div class="indentation-container flex-grow-1 flex-shink-1">
          <template v-if="article.meanings.length > 1">
            <ArticleContentElaborations :word="article.word" />
            <div v-if="showElaborationsSpacing" class="article-content__spacer"></div>

            <template v-for="(meaning, index) in article.meanings" :key="index">
              <ArticleContentMeaning :meaning="meaning" />
              <div class="article-content__spacer"></div>
            </template>
          </template>
          <template v-else>
            <ArticleContentMeaning
              v-if="article.meanings.length === 1"
              :meaning="article.meanings[0]"
              :hide-comment="baseMeaning !== null"
            />
            <ArticleContentElaborations :word="article.word" />
            <div class="article-content__spacer"></div>
          </template>
        </div>
        <div
          v-if="activeIllustrationUrl !== ''"
          class="article-content__image-container d-flex align-items-start justify-content-center"
        >
          <img
            class="article-content__image img-fluid"
            :src="activeIllustrationUrl"
            :alt="
              $t('article.illustration.alt', {
                word: article.headWord
              })
            "
          />
        </div>
      </div>
    </ArticleContentCollapser>
  </ArticleContent>
</template>
